import React from 'react'

const Footer = () => {
  return (
    <footer     style={{ background: '#1068a9', position: 'sticky', zIndex: 1000 }}  class="bg-white rounded-lg  dark:bg-gray-800">
    <div class="w-full mx-auto max-w-screen-xl p-4 md:flex md:items-center md:justify-between">
      <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2023 <a href="https://flowbite.com/" class="hover:underline">Surya</a>. All Rights Reserved.
    </span>
   
    </div>
</footer>
  )
}

export default Footer